/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Pick_4_PickInputs */

const en_pc_alt_pick_4_pick = /** @type {(inputs: Pc_Alt_Pick_4_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft for organizing and filling, Okular for reading and annotating, PDFsam Basic for page work in bulk.`)
};

const zh_pc_alt_pick_4_pick = /** @type {(inputs: Pc_Alt_Pick_4_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`整理和填写用 PdfCraft，阅读和批注用 Okular，批量页面处理用 PDFsam Basic。`)
};

/**
* | output |
* | --- |
* | "PdfCraft for organizing and filling, Okular for reading and annotating, PDFsam Basic for page work in bulk." |
*
* @param {Pc_Alt_Pick_4_PickInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_pick_4_pick = /** @type {((inputs?: Pc_Alt_Pick_4_PickInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Pick_4_PickInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_pick_4_pick(inputs)
	return zh_pc_alt_pick_4_pick(inputs)
});
export { pc_alt_pick_4_pick as "pc.alt.pick.4.pick" }